import { useEffect } from "react";

interface SortingProps {
    // Define your prop types here
    sortingActive: any;
	handleSorting: (index: number, href: string) => void;
};

const Sorting: React.FC<SortingProps>  = ({ sortingActive, handleSorting }) => {
	useEffect(() => {
		// Access query parameters
		const urlParams = new URLSearchParams(window.location.search);
		const sort = urlParams.get('sort');
		// Use the values in your component
		
	 
		// You can use the values to update your component's state or perform other actions
	  }, []);
const sortingOptions = {
		items: [
			// {
			// 	text: "Nejoblíbenější",
			// 	href: "favorites"
			// },
			{
				text: "Nejlevnější",
				href: "price"
			},
			{
				text: "Nejnovější",
				href: "created"
			}
		]
	}
	// console.log(sortingOptions.items);
	
	return (
		<div className="inner">
			<ul className="submenu ajax-sort">
				{sortingOptions.items.map((Val, index) => {
					return (
						<li key={index} className={sortingActive == index ? "active" : ""}>
							<a 
								 //href={`/product/?sort=${Val.href}`} 
								 onClick={() => handleSorting(index, Val.href)}>{Val.text}</a>
								 </li>
					)
				})}
			</ul>
		</div>
	)
}

export default Sorting;